module.exports = __webpack_public_path__ + "img/r-ico.cf416939.png";